module.exports = __webpack_public_path__ + "static/media/rsvp-start-guest-list.26b023e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/rsvp/rsvp-start-guest-list.png
// module id = 2704
// module chunks = 70